import { useState, useMemo } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { TrashIcon } from '@heroicons/react/outline';
import useCategories from '../../hooks/useCategories';
import {
  DocumentIcon,
  EyeIcon,
  ClipboardListIcon,
  BellIcon,
} from '@heroicons/react/solid';
import dayjs from 'dayjs';

type Evaluation = {
  email: string;
  evaluationCount: number;
  lastEvaluationDate: Date;
};

const evaluations: Array<Evaluation> = [
  {
    email: 'user234324@gmail.com',
    evaluationCount: 3,
    lastEvaluationDate: new Date(),
  },
  {
    email: 'user34324@gmail.com',
    evaluationCount: 2,
    lastEvaluationDate: new Date(),
  },
  {
    email: 'user12312@gmail.com',
    evaluationCount: 1,
    lastEvaluationDate: new Date(),
  },
  {
    email: 'user123532@gmail.com',
    evaluationCount: 5,
    lastEvaluationDate: new Date(),
  },
  {
    email: 'user1234523@gmail.com',
    evaluationCount: 3,
    lastEvaluationDate: new Date(),
  },
];

const Topics = () => {
  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'email',
        headerClassName: 'bg-gray-100',
        headerName: 'Email',
        flex: 3,
      },
      {
        field: 'evaluationCount',
        headerClassName: 'bg-gray-100',
        headerName: 'Evaluaties ingevuld',
        flex: 1,
      },
      {
        field: 'lastEvaluationDate',
        headerName: 'Laatste evaluatie',
        headerClassName: 'bg-gray-100',
        valueFormatter: (params: any) => {
          return dayjs(params.value).format('DD-MM-YYYY');
        },
        flex: 1.75,
      },
      {
        field: 'custom-01',
        headerName: '',
        flex: 1,
        headerClassName: 'bg-gray-100',
        renderCell: (params) => {
          return (
            <button
              onClick={() => {}}
              title="Feedback"
              className="rounded-md p-2 space-x-1 w-full flex justify-center"
            >
              <EyeIcon className="w-5 text-gray-500" />
            </button>
          );
        },
      },
    ];
  }, []);

  return (
    <section className="flex flex-col space-y-5">
      <div className="flex justify-end">
        <button
          className={`bg-sky rounded-md p-2  text-white flex items-center space-x-3`}
          onClick={() => {}}
        >
          <BellIcon className={`w-5`} />
          <p>Notificatie sturen</p>
        </button>
      </div>
      <DataGrid
        autoHeight
        rows={evaluations}
        columns={columns}
        getRowId={(row) => row.email}
        className="bg-white"
      />
    </section>
  );
};

export default Topics;
